import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=56767d71"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=56767d71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports